import { db } from './firebase';
import { doc, setDoc } from 'firebase/firestore';

// 기기별 최근 접속 시간 추적
// 직원관리(EmployeeTab) "로그인" 컬럼이 읽는 logins 문서의 필드를 갱신:
//   l_last_login_mobile(핸드폰) / l_last_login_pad(패드) / l_last_login_pc(PC) + l_last_login(공통)
// 각 기기가 홈 진입 시 + 5분마다 자기 접속시간을 기록.

// 화면 가로폭 기준 간단 판별: 핸드폰(<768) / 패드(768~1024) / PC(>1024)
export function detectDeviceType() {
  if (typeof window === 'undefined') return 'pc';
  const ua = navigator.userAgent || '';
  const mtp = navigator.maxTouchPoints || 0;
  // iPadOS 13+ 는 UA가 Macintosh로 위장 → 터치 포인트로 구분
  const isIpad = /iPad/.test(ua) || (/Macintosh/.test(ua) && mtp > 1);
  const isAndroidTablet = /Android/.test(ua) && !/Mobile/.test(ua);
  if (/iPhone|iPod/.test(ua) || (/Android/.test(ua) && /Mobile/.test(ua))) return 'phone';
  if (isIpad || isAndroidTablet) return 'pad';
  const w = window.innerWidth || document.documentElement.clientWidth || 0;
  if (w < 768) return 'phone';
  if (w <= 1024) return 'pad';
  return 'pc';
}

const FIELD_BY_TYPE = {
  phone: 'l_last_login_mobile',
  pad: 'l_last_login_pad',
  pc: 'l_last_login_pc',
};

function nowStr() {
  const d = new Date();
  const p = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`;
}

// 내 접속 시간 기록 (현재 기기 종류 필드 + 공통 필드)
export async function reportDeviceAccess(mcode) {
  if (!mcode) return;
  const field = FIELD_BY_TYPE[detectDeviceType()];
  const ts = nowStr();
  await setDoc(doc(db, 'logins', String(mcode)), { [field]: ts, l_last_login: ts }, { merge: true });
}
